import { render, staticRenderFns } from "./ContentPageLayout.vue?vue&type=template&id=0ce1f73f&scoped=true"
import script from "./ContentPageLayout.vue?vue&type=script&lang=ts"
export * from "./ContentPageLayout.vue?vue&type=script&lang=ts"
import style0 from "./ContentPageLayout.vue?vue&type=style&index=0&id=0ce1f73f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce1f73f",
  null
  
)

export default component.exports